import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainerCustom from "../../components/Common/TableContainerCustom";
import { Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { usePropertyCols } from "./PropertyListMemo";
import { withTranslation } from "react-i18next";
import { modalPropertyShow } from "../../store/actions";
import { getAreas } from "store/Config/actions";
import FormUploadImages from "./FormUploadImages";
import { getProperties as fetchProperties, getPropertyQr, setProperty, setShowModalPropertyDelete, deleteProperty as onDeleteProperty } from "store/Property/actions";
import FormPropertyWizard from "./FormPropertyWizard";
  import toastr from "toastr";
import PDFViewer from "components/Common/PDFViewer/PDFViewer";
import ModalFormGetReceiptProperty from "./ModalFormGetReceiptProperty";

const PropertyList = (props) => {
    const dispatch = useDispatch();

    const { properties, propertyModalShow, totalItems, propertygetQrSuccess, propertyQr, areas, propertyDeletedModalShow, propertyDeleted} = useSelector(state => ({
        properties: state.PropertyReducer.properties,
        propertyModalShow: state.PropertyReducer.propertyModalShow,
        totalItems: state.PropertyReducer.totalItems,
        propertygetQrSuccess: state.PropertyReducer.propertygetQrSuccess,
        propertyQr: state.PropertyReducer.propertyQr,
        areas: state.ConfigInit.areas,
        propertyDeletedModalShow: state.PropertyReducer.propertyDeletedModalShow,
        propertyDeleted: state.PropertyReducer.propertyDeleted,
    }));

    const [isEdit, setIsEdit] = useState(false);
    const [propertyL, setPropertyL] = useState(null);
    const [uploadImgModal, setUploadImgModal] = useState(false);
    const [qrCodeModalShow, setQrCodeModal] = useState(false);
    const [receiptPropertyModalShow, setReceiptPropertyModalShow] = useState(false);
    const [areaListL, setAreaListL] = useState([]);

    const handleOpenUploadImgModal = () => {
        setUploadImgModal(!uploadImgModal);
    };

    useEffect(() => {
         dispatch(getAreas({for_: 'inventory', active:true}));
    }, []);

    useEffect(() => {
        setAreaListL(areas);
    },[areas]);

    const handleHlandleGetQr = (property) => {
        //setPropertyL(property)
        let qrCodeModalShowL = !qrCodeModalShow;
        if(qrCodeModalShowL) {
            dispatch(getPropertyQr (property))
        } else {
            setQrCodeModal(qrCodeModalShowL)
        }
    }

    const toggleReceiptPropertyModal = (property) => {
        let receiptPropertyModalShowL = !receiptPropertyModalShow;
        setReceiptPropertyModalShow(receiptPropertyModalShowL)
        setPropertyL(property)
        if(!receiptPropertyModalShowL) {
            setPropertyL(null)
        }
    }

    useEffect(()=>{
        if(propertyDeleted) {
            setPropertyL(null)
            dispatch(setShowModalPropertyDelete(false))
        }
    },[propertyDeleted]);

    const [typeEdition, setTypeEdition] = useState(null)
    const handleSetEditProperty = (property, typeEdition=null) => {
        setPropertyL(property)
        dispatch(setProperty(property))
        setIsEdit(true)
        setTypeEdition(typeEdition)
        dispatch(modalPropertyShow(true))
    }

    const toggleQrCodeModal = () => {
        setQrCodeModal(!qrCodeModalShow);
    }

    /**
     * @param {*} pagination
     *
     */
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
        search: {
            param: null,
            filter: null
        }
    });

    const toogleModalDeleteProperty = () => {        
        let propertyDeletedModalShowL = !propertyDeletedModalShow;
        if(!propertyDeletedModalShowL) {
            setPropertyL(null)
        }
        dispatch(setShowModalPropertyDelete(propertyDeletedModalShowL))
    }

    const handleSetDeleteProperty = (property) => {     
        let propertyLL = {...property}         
        setPropertyL(propertyLL)        
        toogleModalDeleteProperty()
    }    

    const handlePropertyDeleteSave = () => {       
        dispatch(onDeleteProperty(propertyL))
    }

    const handlePageChange = (newPage, search) => {
        setPagination(prev => ({
            ...prev,
            page: newPage,
            search: search || prev.search
        }));
    };

    const [imagesWithOutUpload, setImagesWithOutUpload]  = useState(0)
    const handleImagesWithOutOpload = val => {
        setImagesWithOutUpload(val)
    }

    const toggleModalAddProperty = () => {
        if( imagesWithOutUpload >0) {
            toastr.warning("Tienes imágenes sin subir, por favor sube todas las imágenes antes de salir")
            return false;
        }
        let propertyModalShowL = !propertyModalShow;
        dispatch(modalPropertyShow(propertyModalShowL));
        if(!propertyModalShowL) {
            setPropertyL(null)
            setIsEdit(false)
        }
    };

    useEffect(()=> {
        dispatch(fetchProperties({
            page: pagination.page,
            pageSize: pagination.pageSize,
            search: pagination.search
        }));
  }, [pagination.page, pagination.pageSize, pagination.search]);

    useEffect(() => {
        //dispatch(fetchProperties());
    }, []);

    const handleFilterCustom = (filter, param) => {       
        setPagination(prev => ({
            ...prev,
            search: {
                param: param,
                filter: filter?.id ? filter.id : filter
            }
        }));
    }

    useEffect(() => {
        console.log("propertygetQrSuccess", propertygetQrSuccess)
        if(propertygetQrSuccess && propertyQr) {
            setQrCodeModal(true)
        }
    },[propertygetQrSuccess, propertyQr]);

    const memoPropertyCols = usePropertyCols(properties, handleSetEditProperty, handleSetDeleteProperty, handleHlandleGetQr, toggleReceiptPropertyModal);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Bienes")}
                        breadcrumbItem={props.t("Listado")}
                    />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerCustom
                                        className="" addBtnNewFlag={true} addFilterCustomFlag={true} handleFilterCumstom={handleFilterCustom}
                                        lblBtnAddNew = "Alta de nuevo Bien" selectItems = {areaListL}
                                        handleAddNewClick={toggleModalAddProperty} onRemoteFilterChange={handleFilterCustom}
                                        data={properties}
                                        isGlobalFilter={false} 
                                        
                                        isAddOptions={false} 
                                        serverSidePagination={{
                                            totalItems: totalItems,
                                            currentPage: pagination.page,
                                            onPageChange: handlePageChange,
                                            search: pagination.search
                                        }} customPageSize={pagination.pageSize}
                                        columns={memoPropertyCols} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Modal size={"xl"} isOpen={propertyModalShow} backdrop={'static'} toggle={toggleModalAddProperty}>
                        <ModalHeader toggle={ toggleModalAddProperty } tag="h4">
                            {isEdit ? typeEdition === "Discontinued" ? "Dar de Baja" : "Editar propiedad" : "Nueva propiedad"}
                        </ModalHeader>
                        <ModalBody>
                            <Row>           
                                <FormPropertyWizard typeEdition={typeEdition} isEdit={isEdit} handleImagesWithOutOpload={handleImagesWithOutOpload} 
                                toggleModalAddProperty={toggleModalAddProperty} property={propertyL} />
                            </Row>
                        </ModalBody>
                    </Modal>
                    <Modal size={"xl"} isOpen={uploadImgModal} backdrop={'static'} toggle={handleOpenUploadImgModal}>
                        <ModalHeader toggle={handleOpenUploadImgModal} tag="h4">
                            {isEdit ? "Editar Imágenes" : "Agregar Imágenes"}
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <FormUploadImages />
                            </Row>
                        </ModalBody>
                    </Modal>
                    
                    <PDFViewer docData={propertyQr} isOpen={qrCodeModalShow} toggle={handleHlandleGetQr}/>

                    <Modal size={"lg"} isOpen={propertyDeletedModalShow} backdrop={'static'} toggle={toogleModalDeleteProperty}>
                        <ModalHeader toggle={toogleModalDeleteProperty} tag="h4">
                            {"Eliminar Registro"}
                        </ModalHeader>
                        <ModalBody>
                            <Row>           
                                <h5>¿Estás seguro de querer eliminar esta propiedad?</h5>
                                <div className="">
                                    <label className=" text-danger text-center  p-1" style={{width:'100%'}} >
                                        {propertyL?.num_inventory} - {propertyL?.concept}, {propertyL?.description}
                                    </label>
                                    <label className="text-danger text-center  p-1" style={{width:'100%'}} >
                                        {'La eliminación de esta propiedad no se puede deshacer'}
                                    </label>
                                </div>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={toogleModalDeleteProperty}>No, Regresar</Button>
                            <Button color="danger" onClick={() => handlePropertyDeleteSave(propertyL)}> SI, Eliminar</Button>
                        </ModalFooter>
                    </Modal>

                    <ModalFormGetReceiptProperty property={propertyL} receiptPropertyModalShow={receiptPropertyModalShow} toggleReceiptPropertyModal={toggleReceiptPropertyModal} />
                </Container>
            </div>
        </React.Fragment>
    )

}
export default withTranslation()(PropertyList);